import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function EditAdminUser() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        status: "Active", // Default status
        permissions: {
            userManagement: false,
            assigningJobs: false,
            serviceManagement: false,
            pricingManagement: false,
            orders: false,
            return: false,
            banners: false,
            tiffinPlan: false,
            supports: false,
            others: false,
            settings: false,
        },
    });

    const [disableBtn, setDisableBtn] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.data;  // Received data for the admin user to be edited

    useEffect(() => {
        if (data) {
            setFormData({
                name: data.name || "",
                email: data.email || "",
                phone: data.phone || "",
                address: data.address || "",
                password: "",
                status: data.status,
                permissions: data.permissions || formData.permissions, // Assume data.permissions contains permission info
            });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;

        if (name.startsWith("permissions")) {
            const permissionName = name.split(".")[1];
            setFormData({
                ...formData,
                permissions: {
                    ...formData.permissions,
                    [permissionName]: e.target.checked,
                },
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisableBtn(true);

        try {
            const headers = {
                "Content-Type": "application/json", // JSON content type
                Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
            };

            // Create the JSON data to send
            const requestData = {
                userId: data._id,
                email: formData.email,
                name: formData.name,
                phone: formData.phone,
                status: formData.status,
                password: formData.password || undefined,  // Only include password if it's provided
                permissions: formData.permissions, // Permissions as an object
            };

            // Remove password if it's not provided (for cleaner data)
            if (!requestData.password) {
                delete requestData.password;
            }

            // Send the request with the JSON body
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/admin/edit-admin-user`, // Adjust the endpoint as needed
                requestData,
                { headers }
            );

            if (response.data.statusCode === 200) {
                navigate(-1);
                toast.success(response?.data?.message);
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to edit admin user. Please try again.");
        }

        setDisableBtn(false);
    };


    return (
        <>
            <Layout>
                <ToastContainer />
                <div>
                    <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
                        {/* Header */}
                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-medium">Edit Admin User</h2>
                        </div>
                        <div className="mt-10" onSubmit={handleSubmit}>
                            <form action="">
                                {/* Name */}
                                <div className="">
                                    <label htmlFor="" className="text-sm">
                                        Name
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                                        placeholder="Admin Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                {/* Email */}
                                <div className="mt-4">
                                    <label htmlFor="" className="text-sm">
                                        Email
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="email"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                        placeholder="Admin Email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                {/* Phone */}
                                <div className="mt-4">
                                    <label htmlFor="" className="text-sm">
                                        Phone
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                        placeholder="Admin Phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                {/* Password */}
                                <div className="mt-4">
                                    <label htmlFor="" className="text-sm">
                                        Password
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="password"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                        placeholder="Admin Password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {/* Status */}
                                <div className="mt-4">
                                    <label htmlFor="" className="text-sm">
                                        Status
                                    </label>{" "}
                                    <br />
                                    <select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>

                                {/* Permissions */}
                                <div className="mt-6">
                                    <h3 className="text-sm">Permissions</h3>
                                    <div className="grid grid-cols-2 gap-4 mt-2">
                                        {Object.keys(formData.permissions).map((permission) => (
                                            <div key={permission} className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name={`permissions.${permission}`}
                                                    checked={formData.permissions[permission]}
                                                    onChange={handleInputChange}
                                                />
                                                <span className="ml-2 capitalize">{permission.replace(/([A-Z])/g, ' $1').toLowerCase()}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="mt-8 text-end">
                                    <button
                                        type="submit"
                                        className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                                        disabled={disableBtn}
                                    >
                                        <i className="fa fa-plus"></i> {disableBtn ? "Editing ..." : "Edit Admin User"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
